<template>
  <div class="item card">
    <div class="content">

      <h4 class="font-11 txt-bold break-word">{{ this.data.title }}</h4>

      <!-- selite -->
      <div class="mt-2">
        <div v-html="this.data.text" class="text-content-html pt-1"></div>
      </div>

      <!-- kuva(t) -->
      <div v-for="(img, index) in data.imgTextPairs" :key="index">
        <!--- <img v-if="data.img" :src="data.img" alt="" class="w-full pointer" @click="setPopupContent(data.img, data.imgText)"> -->
        <img v-if="img.thumbM" :src="img.thumbM" alt="" class="w-full pointer mt-2" @click="setPopupContent(img.image, img.imageText)">
        <img v-else :src="img.image" alt="" class="w-full pointer mt-2" @click="setPopupContent(img.image, img.imageText)">
        <div v-if="img.imageText" v-html="img.imageText" class="image-text-field-in-card font-8 lheight-11 color-grey-d1 mb-2"></div>
        <!-- <div v-if="img.imageText" class="relative font-8 lheight-11 color-grey-d1 mb-2">{{ img.imageText }}</div> -->
        <!-- <p v-if="img.imageText" class="font-8 lheight-11 color-grey-d1 mb-2">{{ img.imageText }}</p> -->
      </div>

      <div class="h-2"></div> <!-- for visual reasons -->

    </div>

  </div>
</template>

<script>
export default {
  name: 'GitemMean',

  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },

  data () {
    return {
      popup: false
    }
  },

  computed: {
    setClass () {
      return ['group-' + this.data.ref]
    }
  },

  methods: {
    setPopupContent (img, imgText) {
      this.$store.dispatch('setPopupContent', {
        img: img,
        imgText: imgText
      })
    }

  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/styles.scss";
</style>
